import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import BaseForm from './shared/base-form.vue'
import ResourceForm from './shared/resource-form-shared.vue'
import { store } from './store'


export default /*#__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

const { edit } = store

const step = ref('0')

watch(
  () => store.edit.visible,
  () => {
    step.value = '0'
  }
)

function onSubmit() {
  store.edit.onEditSubmit()
}

return { __sfc: true,edit, step, onSubmit, BaseForm, ResourceForm }
}

})